import { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ResponsiveContext, Page, PageContent, PageHeader, Layer, Spinner, Text } from "grommet";
// import header_image from "../../../static/img/hpe_storage.jpg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { storageActions } from "../redux/actions/storageActions";
import { StorageDashboardGrid } from "./storageDashboardGrid";


function StorageDashboard() {
    const size = useContext(ResponsiveContext);
    const history = useHistory();
    const dispatch = useDispatch();
    // const StyledTextInput = styled(TextInput).attrs(() => ({
    //     'aria-labelledby': 'search-icon',
    // }))``;
    // const [searchValue, setSearchValue] = useState("");
    // const card_desc = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"

    const session = useSelector((state) => {
        return state.session;
    });

    // const user = useSelector((state) => {
    //     return state.session.user;
    // });

    useEffect(() => {
        if (session && session.user && session.user.access) {
            dispatch(storageActions.getApplications(session.user.access));
        }
    }, [dispatch, session]);

    const applicationsList = useSelector((state) => {
        return state.storageApplication.applications
    });
    return (
        <>
            <Page>
                <PageContent gap={"medium"} >
                    <PageHeader title={"Hybrid Cloud Sales Tool"} subtitle={"An application where you get all your sales needs fullfiled"}
                    // subtitle={"An Application to fulfill your competitive needs"} 
                    />
                    {/* <Box width={"medium"}>
                        <StyledTextInput icon={<Search id="search-icon" color="placeholder" />} placeholder="Search" reverse value={searchValue} onChange={event => setSearchValue(event.target.value)} type="search" />
                    </Box> */}
                    {(applicationsList.requestInProgress) && (
                        <Layer position='center' background='none' style={{ boxShadow: "none" }}>
                            <Spinner />
                        </Layer>
                    )}
                    {applicationsList.data && applicationsList.data.length > 0 ? (
                        <StorageDashboardGrid applicationsList={applicationsList} history={history} size={size} />
                    ) : <Text>
                        No Applications
                    </Text>}
                    {/* {singleClickList.data && singleClickList.data.length > 0 ? (
                        <CompetetiveDashboardGrid competitorsList={singleClickList.data} history={history} size={size} />
                    ) : <></>} */}
                </PageContent>
            </Page>
        </>
    );
}

export default StorageDashboard